// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1224":"ac9cd88e","3375":"82cc515a"}[chunkId] + ".chunk.css";
};